module.exports = __webpack_public_path__ + "img/D201502_2.fe55cd10.jpg";